import type {
  GoogleCompleteSignupDto,
  GoogleConnectionStatusDto,
  GooglePendingSignupDto,
} from '@paladin-monorepo/common';
import API from '../api';
import { trackEvent } from '../analytics';

export const googleApi = {
  async getPendingSignup(): Promise<GooglePendingSignupDto> {
    return API.get<GooglePendingSignupDto>('/auth/google/pending-signup').then((res) => res.data);
  },

  async completeSignup(dto: GoogleCompleteSignupDto) {
    return API.post('/auth/google/complete-signup', dto).then((res) => {
      trackEvent('sign_up', { method: 'google' });
      return res.data;
    });
  },

  async getConnectionStatus(): Promise<GoogleConnectionStatusDto> {
    return API.get<GoogleConnectionStatusDto>('/me/google/status').then((res) => res.data);
  },

  async disconnect(): Promise<void> {
    await API.delete('/me/google');
  },
};
